module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAOCAYAAAArMezNAAAABHNCSVQICAgIfAhkiAAAALVJREFUOI3V0DESgjAUBNBduJRIQzyJN4AGSgOU2ugRPEligYOX8lswcTKjQKBjq59J9s2fAJtNW+amqYp6bb+pirotc+POkRuEfACi1+BDR/RgDIndYLveqjQhIFqlCW3X2yUowEafr9+lYv/RUnwM/YGX4FPoXzgEn0NHYYcf9rsMxNHHQ1AA4NiFS1vmRohMIiq+kQGiKbCny01N9WZhHweAEBSY+Ao/5vm6qzQhBQhBt5kPZEZ1Mnzl9AgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/drop-down.png
// module id = 3VOX
// module chunks = 1